import Content from '../content-interface';

export default class CalculationRuleApplyFailedHistory implements Content {
  itemNumber: number | null;

  productTemplateId: string | null;

  productTemplateDescription: string | null;

  ruleName: string | null;

  errorMessage: string | null;

  errorClass: string;

  constructor(obj: any = {}) {
    this.itemNumber = obj.itemNumber ?? null;
    this.productTemplateId = obj.productTemplateId ?? null;
    this.productTemplateDescription = obj.productTemplateDescription ?? null;
    this.ruleName = obj.ruleName ?? null;
    this.errorMessage = obj.errorMessage ?? null;
    this.errorClass = obj.errorClass ?? '';
  }

  static of(obj: any = {}): CalculationRuleApplyFailedHistory {
    return new CalculationRuleApplyFailedHistory(obj);
  }
}
